import Spinner from "../../ui/spinner/Spinner";
import styles from "../ContentItem.module.scss";
import CategoryPageItem from "./CategoryPageItem";
import { CategoryType } from "./OnPage";
import { ApprovePayload, PageItem } from "./types";

interface PendingStatus {
  id: number;
  status: string;
  widget_recommendation_id: number;
  variant: string;
  approved: boolean;
}

interface CategoryPageItemsProps {
  data: PageItem[];
  currentCategory: CategoryType | undefined;
  approve: (data: ApprovePayload) => void;
  isApprovePending: boolean;
  isPagesTypeLoading: boolean;
  approvePermission: boolean;
  pendingStatuses: PendingStatus[];
  isFetchingPendingStatusesAndPermissionsPageType: boolean;
  isWidgetActionLoading: boolean;
  isDetailsLoading: boolean;
  editPageSuggestion: (data: { id: number; final: string }) => void;
  fetchDetails: (pageId: number) => Promise<void>;
}

const CategoryPageItems = ({
  data,
  currentCategory,
  approve,
  isApprovePending,
  isPagesTypeLoading,
  approvePermission,
  pendingStatuses,
  isFetchingPendingStatusesAndPermissionsPageType,
  isWidgetActionLoading,
  isDetailsLoading,
  editPageSuggestion,
  fetchDetails,
}: CategoryPageItemsProps) => {
  const isLoading =
    isApprovePending ||
    isPagesTypeLoading ||
    pendingStatuses.length > 0 ||
    isFetchingPendingStatusesAndPermissionsPageType;
  const isDisabled =
    isLoading || !approvePermission || pendingStatuses.length > 0;

  if (isDetailsLoading && data.length === 0) {
    return (
      <div className={styles.currentItemSpinner}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={styles.currentItemGroup}>
      {data?.map((item, index) => {
        const hasPendingStatus = item?.details?.some((detail) =>
          pendingStatuses?.some((status) => status.id === detail.id),
        );

        return (
          <CategoryPageItem
            key={item.id}
            editPageSuggestion={editPageSuggestion}
            isWidgetActionLoading={isWidgetActionLoading}
            isDisabled={isDisabled}
            isLoading={isLoading}
            approve={approve}
            currentCategory={currentCategory}
            hasPendingStatus={hasPendingStatus}
            item={item}
            isDefaultOpen={index === 0}
            fetchDetails={fetchDetails}
          />
        );
      })}
    </div>
  );
};

export default CategoryPageItems;
